import React from 'react';
import LegalLayout from './LegalLayout';

export default function CGU() {
  return (
    <LegalLayout badge="Légal" title="Conditions Générales d'Utilisation" date="Dernière mise à jour : avril 2025">
      <div className="legal-toc">
        <div className="legal-toc-title">Sommaire</div>
        <ol className="legal-toc-list">
          {['Objet et champ d\'application','Accès au service','Création de compte','Description du service','Plans et facturation','Obligations de l\'utilisateur','Responsabilités','Propriété intellectuelle','Résiliation','Modification des CGU','Droit applicable'].map((t,i) => (
            <li key={i}><a href={`#art${i+1}`}>{i+1}. {t}</a></li>
          ))}
        </ol>
      </div>

      <div className="legal-content">
        <div className="legal-block" id="art1">
          <h2>1. Objet et champ d'application</h2>
          <p>Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de définir les modalités d'accès et d'utilisation de l'application <strong>Clockeo</strong>, accessible à l'adresse <a href="https://clockeo.fr">clockeo.fr</a>.</p>
          <p>En accédant au service ou en créant un compte, l'utilisateur accepte sans réserve les présentes CGU. Si l'utilisateur n'accepte pas ces conditions, il doit s'abstenir d'utiliser le service.</p>
        </div>

        <div className="legal-block" id="art2">
          <h2>2. Accès au service</h2>
          <p>Clockeo est une application web progressive (PWA) accessible depuis tout appareil disposant d'un navigateur compatible et d'une connexion internet. L'application est disponible sur :</p>
          <ul>
            <li>Navigateur web (Chrome, Firefox, Safari, Edge)</li>
            <li>Appareils mobiles Android et iOS via installation PWA</li>
            <li>Ordinateurs de bureau via Chrome ou Edge</li>
          </ul>
          <p>Clockeo se réserve le droit d'interrompre temporairement l'accès au service pour des raisons de maintenance, sans que cela ne donne lieu à une indemnisation.</p>
        </div>

        <div className="legal-block" id="art3">
          <h2>3. Création de compte</h2>
          <h3>3.1 Inscription</h3>
          <p>L'accès à Clockeo requiert la création d'un compte. L'inscription est possible :</p>
          <ul>
            <li>Pour les <strong>administrateurs d'entreprise</strong> : via un code d'invitation fourni par Clockeo</li>
            <li>Pour les <strong>employés</strong> : via invitation de leur administrateur d'entreprise</li>
          </ul>
          <h3>3.2 Exactitude des informations</h3>
          <p>L'utilisateur s'engage à fournir des informations exactes, complètes et à jour lors de son inscription. Toute fausse déclaration peut entraîner la suspension ou la suppression du compte.</p>
          <h3>3.3 Confidentialité des identifiants</h3>
          <p>L'utilisateur est seul responsable de la confidentialité de ses identifiants de connexion. Il s'engage à notifier immédiatement Clockeo en cas d'utilisation non autorisée de son compte.</p>
        </div>

        <div className="legal-block" id="art4">
          <h2>4. Description du service</h2>
          <p>Clockeo est une application de gestion du temps de présence pour équipes terrain. Le service comprend notamment :</p>
          <ul>
            <li>Pointage d'entrée et de sortie par QR code ou géolocalisation GPS</li>
            <li>Supervision en temps réel des équipes</li>
            <li>Gestion des sites, équipes et utilisateurs</li>
            <li>Historique des pointages et export de données</li>
            <li>Tableau de bord et statistiques de présence</li>
          </ul>
          <p>Les fonctionnalités disponibles varient selon le plan d'abonnement souscrit.</p>
        </div>

        <div className="legal-block" id="art5">
          <h2>5. Plans et facturation</h2>
          <h3>5.1 Plans disponibles</h3>
          <p>Clockeo propose les plans suivants :</p>
          <ul>
            <li><strong>Gratuit</strong> : 0 € / mois — jusqu'à 1 site, 10 utilisateurs, 2 équipes</li>
            <li><strong>Pro</strong> : 29 € / mois — jusqu'à 5 sites, 50 utilisateurs, 10 équipes</li>
            <li><strong>Business</strong> : 79 € / mois — sites, utilisateurs et équipes illimités</li>
          </ul>
          <h3>5.2 Facturation</h3>
          <p>La facturation est mensuelle. Le paiement s'effectue en début de période. Aucun remboursement ne sera accordé en cas de résiliation en cours de mois.</p>
          <h3>5.3 Évolution tarifaire</h3>
          <p>Clockeo se réserve le droit de modifier ses tarifs avec un préavis d'un mois. L'utilisateur sera notifié par email avant toute modification tarifaire.</p>
          <div className="legal-warning">
            <p>⚠️ Les prix affichés sont en euros hors taxes. La TVA applicable sera ajoutée selon la réglementation en vigueur.</p>
          </div>
        </div>

        <div className="legal-block" id="art6">
          <h2>6. Obligations de l'utilisateur</h2>
          <p>L'utilisateur s'engage à :</p>
          <ul>
            <li>Utiliser le service conformément à sa destination et aux présentes CGU</li>
            <li>Ne pas tenter de contourner les mécanismes de sécurité de l'application</li>
            <li>Ne pas utiliser le service à des fins frauduleuses ou illicites</li>
            <li>Ne pas partager ses identifiants avec des tiers non autorisés</li>
            <li>Respecter la vie privée des autres utilisateurs</li>
            <li>Signaler toute anomalie ou faille de sécurité à Clockeo</li>
          </ul>
          <p>L'utilisateur administrateur est également responsable du respect de ces conditions par les membres de son organisation.</p>
        </div>

        <div className="legal-block" id="art7">
          <h2>7. Responsabilités</h2>
          <h3>7.1 Responsabilité de Clockeo</h3>
          <p>Clockeo s'engage à mettre en œuvre les moyens nécessaires pour assurer la disponibilité et la sécurité du service. Toutefois, Clockeo ne peut garantir une disponibilité ininterrompue du service.</p>
          <p>Clockeo ne saurait être tenue responsable de tout dommage indirect résultant de l'utilisation ou de l'impossibilité d'utiliser le service.</p>
          <h3>7.2 Responsabilité de l'utilisateur</h3>
          <p>L'utilisateur est seul responsable de l'utilisation qu'il fait du service et des données qu'il y enregistre. En qualité d'employeur, l'administrateur reste seul responsable de la légalité du dispositif de pointage mis en place vis-à-vis de ses employés et des obligations légales applicables (information des salariés, RGPD, etc.).</p>
        </div>

        <div className="legal-block" id="art8">
          <h2>8. Propriété intellectuelle</h2>
          <p>Clockeo et tous ses éléments constitutifs (marque, logo, design, code source, base de données) sont la propriété exclusive de Clockeo et sont protégés par le droit de la propriété intellectuelle.</p>
          <p>L'utilisateur dispose uniquement d'un droit d'utilisation personnel, non exclusif et non transférable du service, dans les conditions prévues par les présentes CGU.</p>
        </div>

        <div className="legal-block" id="art9">
          <h2>9. Résiliation</h2>
          <h3>9.1 Par l'utilisateur</h3>
          <p>L'utilisateur peut résilier son compte à tout moment depuis les paramètres de son compte ou en contactant <a href="mailto:contact@clockeo.fr">contact@clockeo.fr</a>. La résiliation prend effet à la fin de la période de facturation en cours.</p>
          <h3>9.2 Par Clockeo</h3>
          <p>Clockeo se réserve le droit de suspendre ou de résilier un compte en cas de violation des présentes CGU, sans préavis ni indemnité.</p>
          <h3>9.3 Conséquences</h3>
          <p>En cas de résiliation, les données de l'utilisateur sont conservées pendant 30 jours puis supprimées définitivement, sauf obligation légale de conservation.</p>
        </div>

        <div className="legal-block" id="art10">
          <h2>10. Modification des CGU</h2>
          <p>Clockeo se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de toute modification substantielle par email ou par notification dans l'application, avec un préavis de 15 jours.</p>
          <p>La poursuite de l'utilisation du service après entrée en vigueur des nouvelles CGU vaut acceptation de celles-ci.</p>
        </div>

        <div className="legal-block" id="art11">
          <h2>11. Droit applicable et juridiction</h2>
          <p>Les présentes CGU sont soumises au droit français. En cas de litige relatif à l'interprétation ou à l'exécution des présentes conditions, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire.</p>
          <p>À défaut d'accord amiable, le litige sera soumis aux tribunaux compétents du ressort du siège social de Clockeo.</p>
          <div className="legal-highlight">
            <p>Pour toute question ou réclamation : <a href="mailto:contact@clockeo.fr">contact@clockeo.fr</a></p>
          </div>
        </div>
      </div>
    </LegalLayout>
  );
}
